<template>
  <v-app>
    <v-main style="background-color: #ffffff" class="center">
      <v-img src="@/assets/img/onsa-logo.png"
             @mousemove="logo_img_handler"
             class="mobile-logo mx-auto my-auto" width="300px" height="auto"></v-img>
      <v-container class="login-box mx-auto">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-card color="#f2f2f2" class="rounded-xl text--lighten-4 elevation-0 text-center">
            <v-row>
              <v-col cols="12" class="text-center login-form-title">تایید کار</v-col>
              <v-col cols="12" class="mw-300 mx-auto form-box mb-5 text-center">
                <v-card-text >
                  <v-text-field dir="ltr" label="شماره تماس"
                                v-model="mobile_number"
                                :rules="[rules.required]"
                                class="elevation-0"
                                outlined rounded dense/>
                  <v-text-field dir="ltr" label="شماره کار"
                                v-model="task_id"
                                :rules="[rules.required]"
                                class="elevation-0"
                                outlined rounded dense/>
                  <v-btn @click="submit_confirm_data" :loading="loading" :disabled="!(mobile_number && task_id)"
                         block color="success" class="mt-5 submit-btn">
                    تایید
                  </v-btn>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
@import '@/assets/css/login.css';
</style>

<script>
import axios from "axios";

export default {
  name: 'ConfirmTask',

  data: () => ({
    //
    task_id:'',
    mobile_number:'',
    loading:false,
    rules: {
      required: value => !!value || 'اجباری',
      min: v => v.length >= 8 || 'حداقل ۸ حرف',
    },
  }),
  created() {
    this.mobile_number = this.$route.query.mobile_number;
    this.task_id = this.$route.query.id;
  },
  methods:{
    submit_confirm_data(){
        this.loading = true;
        axios.post(this.BACKEND_LINK + '/api/task/confirm/',{
          id : this.task_id,
          mobile_number : this.mobile_number
        })
            .then((response)=>{
              this.$snotify.success(response.data.msg);
            })
            .catch((error)=>{
              if (error.response.data){
                this.$snotify.error(error.response.data.msg);
              }else {
                this.$snotify.error("لطفا مجدد تلاش کنید");
              }
            })
            .finally(()=>{
              this.loading = false;
            })
      }

    },
    logo_img_handler(e){
      document.getElementById('login_logo_img').style.transform = `perspective(${e.pageX+20<500?500:e.pageX+20}px) rotateY(${(e.pageX/4)-120}deg)`;
    },

};
</script>
